import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { SettlementForm } from '../Forms';
import { Text1 } from '../../../styles';
import { Alert } from 'antd';


const SettlementModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Bank Transfer
            </Text1>
        )
    };
    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={props.toggleSettlementModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            {
                props.settlementEnabled ? (
                    <SettlementForm
                        onSubmit={props.onSubmit}
                        loading={props.loading}
                        settlementAccounts={props.settlementAccounts}
                        settlement_payment_modes={props.settlement_payment_modes}
                        virtualAccount={props.virtualAccount}
                    />
                ) : (
                    <Alert type="warning" showIcon message="Not Allowed" description="This service is disabled for your account." />
                )
            }
        </EaseModal>
    )
};

export { SettlementModal };